/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
/* eslint-disable react/prop-types */
// import RadioGroup from "@mui/material/RadioGroup";
// import React from "react";
// import { RadioGroupWrapperProps } from "./IRadio";

// const RadioGroupWrapper: React.FC<RadioGroupWrapperProps> = ({ children, ...rest }) => {
//   return <RadioGroup {...rest}>{children}</RadioGroup>;
// };

// export default RadioGroupWrapper;



import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";
import { Controller, Control, useFormContext } from "react-hook-form";

type OptionType = {
  value: string | number;
  label: string;
};

type BaseRadioGroupProps = {
  name: string;
  control: Control<any>;
  label: string;
  options: OptionType[];
  rules?: any;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  row?: boolean;
};

const RadioGroupWrapper: React.FC<BaseRadioGroupProps> = ({
  name,
  control,
  label,
  options,
  rules,
  error,
  helperText,
  required = false,
  row = false,
}) => {
  const formContext = useFormContext();
  const trigger = formContext?.trigger ?? (() => {});

  return (
    <FormControl
      component="fieldset"
      error={error}
      required={required}
      fullWidth
      sx={{
        "& .MuiFormLabel-asterisk": {
          color: "#F44336",
        },
      }}
    >
      <FormLabel component="legend">{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={rules}
        render={({ field }) => (
          <RadioGroup {...field} row={row} onBlur={() => trigger(name)}>
            {options.map((option, index) => (
              <FormControlLabel
                key={`${option.value}-${index}`}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        )}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default RadioGroupWrapper;

